function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9681",
  "data-name": "Group 9681",
  transform: "translate(110.341 -24.081)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9685",
  "data-name": "Path 9685",
  d: "M-103.7,34.6a1.315,1.315,0,0,1-.939-.386l-6.158-6.25a1.162,1.162,0,0,1-.108-1.522l2.535-3.38a1.3,1.3,0,0,1,1.045-.509h7.47a1.3,1.3,0,0,1,1.045.51l2.531,3.374a1.159,1.159,0,0,1-.121,1.536l-6.377,6.256A1.314,1.314,0,0,1-103.7,34.6Zm.1-1.411Zm-5.986-6.074,5.885,5.973,6.1-5.982-2.319-3.092h-7.337Zm-.175-.178h0Zm9.78-3h0Z",
  transform: "translate(1 1.674)",
  fill: "#687c97",
  stroke: "#687c97",
  strokeWidth: 0.3
}));

function SvgGrayDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.493,
    height: 12.348,
    viewBox: "0 0 15.493 12.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDiamond);
export default __webpack_public_path__ + "static/media/gray-diamond.30858d53.svg";
export { ForwardRef as ReactComponent };